import {DashboardTileId} from '../types/DashboardTileId';
import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {applyDashboardGridLayout} from './applyDashboardGridLayout';
import {DashboardDropTransaction, getDashboardLayoutSignature} from './projectDashboardDrop';
import {reconcileDashboardGrid} from './reconcileDashboardGrid';

export function reorderDashboardGrid(
  placements: DashboardTilePlacement[],
  transaction: DashboardDropTransaction,
  visibleIds: DashboardTileId[]
): DashboardTilePlacement[] {
  const visibleIdSet = new Set(visibleIds);
  const visiblePlacements = placements.filter((placement) => visibleIdSet.has(placement.id));
  const currentBoard = reconcileDashboardGrid(visiblePlacements);

  if (getDashboardLayoutSignature(currentBoard) !== transaction.baseLayoutSignature) {
    return placements;
  }

  return applyDashboardGridLayout(placements, transaction.board);
}
